import {
  type ApiRequest,
  type ApiResponse,
  type ApiResponseSingle,
  properCallApi
} from '@/api/tenantClient';

export const infoFormResponseQueryKey = 'registration.infoFormResponseList';
export const infoFormResponseTableQueryKey = 'infoFormResponse.table';

export interface InfoFormResponse {
  id: number
  response: Record<string, any>
  eventId: string
  ownerId: number
  ownerType: 'Registration'
  infoFormId: number
  createdAt: string
}

export enum InfoFormType {
  PERSONAL = 'personal',
  ADDITIONAL = 'additional'
}

export interface InfoFormResponseQueryRequest {
  registrationId: number
  type: InfoFormType
}

export function loadRegistrationInfoFormResponse(createTenantAdminRequest: () => ApiRequest) {
  const request = createTenantAdminRequest();
  return async (
    params: InfoFormResponseQueryRequest
  ): Promise<ApiResponseSingle<InfoFormResponse>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/admin/info_form_responses/' + params.registrationId.toString();
    request.endpoint.query = {
      registrationId: params.registrationId.toString(),
      type: params.type
    };
    return await properCallApi<ApiResponseSingle<InfoFormResponse>>(request);
  };
}

export interface InfoFormResponseQueryTableRequest {
  page: number
  filters?: any
  sorting?: any
  size: number
  search?: string
  eventId?: string
  attendeeCategoryId?: string
  formId?: string
}

export interface InfoFormResponseTableRow {
  id: number
  idInfo: string
  attendee: { name: string, email: string }
  attendeeCategory: { name: string }
  event: { timeZoneName: string }
  infoFormResponses: { personal?: Record<string, any>, additional?: Record<string, any> }
  createdAt: string
  status: string
  confirmDelegateTypeAt: string
  registrationType: { name: string }
}

export function loadInfoFormResponseForTable(createTenantAdminRequest: () => ApiRequest) {
  const request = createTenantAdminRequest();
  return async (
    params: InfoFormResponseQueryTableRequest
  ): Promise<ApiResponse<InfoFormResponseTableRow>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/info_form_responses/table';
    request.endpoint.query = {
      eventId: params.eventId,
      attendeeCategoryId: params.attendeeCategoryId,
      formId: params.formId,
      page: (params?.page ?? 0) + 1,
      filters: JSON.stringify(params.filters ?? []),
      sorting: JSON.stringify(params.sorting ?? []),
      size: params.size ?? 10,
      ...params.search ? { search: params.search } : {}
    };
    return await properCallApi<ApiResponse<InfoFormResponseTableRow>>(request);
  };
}
